<template>
	<div class="c-chart-list-item" v-if="chart && chart.fields && !chart.deleted" :class="{ 'fixed': chart.permissions.is_fixed, 'c-chart-list-item--hidden': !chart.visible,  'c-chart-list-item--locked': !chart.permissions.can_edit && chart.permissions.is_fixed,'c-chart-list-item--trashed': chart.trashed, 'c-chart-list-item--child': child }">

		<div class="c-chart-list-item__topbar">
			<span v-if="!child && chart.fields.title && chart.fields.title.value" class="c-chart-list-item__title">
				{{ chart.fields.title.value }}
			</span>
			<div class="c-chart-list-item__actions">
				<button
				v-if="(!collapsed) && chart.permissions.can_delete && chart.permissions"
				@click="$store.commit('TOGGLE_CHART_TRASHED', chart.id)"
				:title="$t('delete Chart')"
				class="no-btn c-chart-list-item__btn c-chart-list-item__btn--delete">
					<i class="fa fa-trash" aria-hidden="true"></i>
				</button>

				<button
				v-if="(!collapsed) && !chart.visible && chart.permissions && chart.permissions.can_change_visible"
				:title="$t('show Chart')"
				@click="$store.commit('TOGGLE_CHART_VISIBILITY', chart.id)"

				class="no-btn c-chart-list-item__btn c-chart-list-item__btn--show">
					<i class="fa fa-eye" aria-hidden="true"></i>
				</button>

				<button
				v-if="(!collapsed) && chart.visible && chart.permissions && chart.permissions.can_change_visible"
				:title="$t('hide Chart')"
				@click="$store.commit('TOGGLE_CHART_VISIBILITY', chart.id)"

				class="no-btn c-chart-list-item__btn c-chart-list-item__btn--hide">
					<i class="fa fa-eye-slash" aria-hidden="true"></i>
				</button>

				<button
				v-if="(!collapsed) && chart.permissions.is_fixed"
				:title="$t('Chart is fixed')"
				@click="$store.commit('TOGGLE_CHART_FIXED', chart.id)"
				class="no-btn c-chart-list-item__btn c-chart-list-item__btn--hide">
					<i class="fa fa-snowflake-o" aria-hidden="true"></i>
				</button>
			</div>
		</div>
		<router-link class="router-link" :to="{ name: presentation_prefix + 'chart', params: { chartid : chart.id }}">
	    	<c-chart-preview
	    		:data="data"
	    		:refreshing="chart.refreshing"
	    		:small="collapsed"
	    		:visible="(parent && !parent.visible ? parent.visible : chart.visible)"
	    		:trashed="(parent && parent.trashed ? parent.trashed : chart.trashed)"
	    		:locked="(!chart.editable)">
	    	</c-chart-preview>
		</router-link>

		<div class="ui-editor__chart-preview-childs" v-if="presentation_type != 'user'">
			<c-chart-list
			:parentid="chart.id"
			:data="data.charts"
			:child="true"
			:canHaveChilds="(chart.permissions && chart.permissions.can_have_childs) && (chart.addablecharts && chart.addablecharts.length > 0) && !(!chart.permissions.can_edit && !chart.permissions.can_change_edit)"></c-chart-list>
		</div>
	</div>
</template>

<script>

import CChartPreview 		from '@/components/p-editor/c-chart-preview';

export default {
	name: 'c-chart-list-item',
	data() {
		return {
			collapsed: false
		};
	},

	components: {
		CChartPreview
	},

	computed: {
		presentation_type(){
			return this.$store.getters.presentation.type;
		},
		presentation_prefix() {
			if(this.$store.getters.presentation && this.$store.getters.presentation.type) return this.$store.getters.presentation.type + '-';
			if(this.$store.getters.presentation.role) return 'user-';
			return '';
		},
		isMaster(){
			return (this.$store.getters.active_presentation == 'master' ? true : false);
		},
		chart(){
			return this.$store.getters.getChartById(this.data.id);
		},
		parent(){
			if(this.parentid == 0) return false;
			return this.$store.getters.getChartById(this.parentid);
		},
	},

	props: {
		parentid: {
			type: Number,
			default: 0
		},
		data: {
			type: Object,
			default(){
				return {};
			}
		},
		child: {
			type: Boolean,
			default: false
		}
	},

}
</script>

<style scoped lang="scss">
	.c-chart-list-item {
		$scope: &;

		&__topbar {
			&:after {
				clear: both;
				content: " ";
				display: block;
				}
			}
			&__title {
				color: #fff;
				float: left;
			}
			&__actions {
				color: #fff;
				float: right;
			}

		&__btn {
			color: #fff;
		}


		&--child {
	    	position: relative;
	    	#{$scope}__topbar {
	    		position: absolute;
			    left: -28px;
			    width: 28px;
			    bottom: 0;
			    top: 0;
	    	}
	    	#{$scope}__actions{
	    		float: none;
	    		width: 100%;
	    		text-align: center;
	    	}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/p-editor/c-chart-list-item.vue